import { Component, OnDestroy, OnInit, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Platform, PopoverController } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { PopupModel } from '../../../types/popup-model';

@Component({
  selector: 'app-pop-up',
  templateUrl: './pop-up.component.html',
  styleUrls: ['./pop-up.component.scss'],
  standalone: true,
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PopUpComponent implements OnInit, OnDestroy {
  private sanitizer = inject(DomSanitizer);
  popupInfo!: PopupModel;
  btn2Enable = true;
  timerEnable: boolean = false;
  timer: number = 0;
  btn2aux: string = '';
  btn2: string = '';
  intervalo: any;
  url1: string = '';
  urlBack1: string = '';
  sub: any;
  constructor(
    public popoverCtrl: PopoverController,
    public platform: Platform,
  ) { }

  ngOnInit() {
    /*     this.sub = this.platform.backButton.subscribeWithPriority(99999, () => {
          this.dismiss(null);
        }); */

    this.btn2 = this.popupInfo.btn2 || '';
    if (this.popupInfo.icon) {
      if (!this.popupInfo.icon?.includes('http')) {
        this.popupInfo.icon = '/assets/icons/' + this.popupInfo.icon;
      }
    }
    if (this.popupInfo.bannerImg) {
      this.popupInfo.bannerImg = '../../../../assets/img/' + this.popupInfo.bannerImg;
    }
    if (this.popupInfo.behavior === 1) {
      this.timerEnable = true;
      this.btn2aux = this.popupInfo.btn2 || '';
      
      // Type guard to ensure data is an object and not a string
      if (this.popupInfo.data && typeof this.popupInfo.data === 'object') {
        this.btn2 = this.popupInfo.data.btn2alter || '';
        const dateNow = this.popupInfo.data.date || Date.now();
        const countdown = this.popupInfo.data.countdown || 0;
        
        this.btn2Enable = false;
        let differenceInSeconds = Math.ceil(countdown - ((Date.now() - dateNow) / 1000));
        this.timer = differenceInSeconds;
        
        this.intervalo = setInterval(() => {
          if (this.timer <= 0) {
            this.timerEnable = false;
            this.btn2Enable = true;
            this.btn2 = this.btn2aux;

            clearInterval(this.intervalo);
            this.clearInter();
          } else {
            differenceInSeconds = Math.ceil(countdown - ((Date.now() - dateNow) / 1000));
            this.timer = differenceInSeconds;
          }
        }, 1000);
      }
    }
  }

  public clearInter() {
    clearInterval(this.intervalo);
  }

  ngOnDestroy() {
    if (this.sub) { this.sub?.unsubscribe(); }
  }

  dismiss(btn: any, url?: string, urlBack?: string) {

    this.sub?.unsubscribe();
    if (url) {
      // Navigation logic should be handled by parent component
      console.log('Navigation requested:', url, urlBack);
      this.popoverCtrl.dismiss({ btn, url, urlBack });
      return;
    }

    if (this.popupInfo.behavior === 3 && btn == 1) {
      // Use native window.open instead of InAppBrowser
      if (typeof this.popupInfo.data === 'string') {
        window.open(this.popupInfo.data, '_blank');
      }
      return;
    }

    if (btn === 2 && !this.btn2Enable) { return; }
    this.popoverCtrl.dismiss(btn);
  }

  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.sanitize(4 /* SecurityContext.HTML */, html) || '';
  }
}
